import React from 'react';
import { Modal } from '../../../../components/containers/Modal';
import { ButtonColorsEnum } from '../../../../constants/button-colors';

export type UnarchiveCategoryModalViewProps = {
  onClose: () => void;
  onSubmit: () => void;
  submitted: boolean;
  categoryId: string;
};

export const UnarchiveCategoryModalView = (props: UnarchiveCategoryModalViewProps): JSX.Element => {
  return (
    <Modal
      closeOnClickOutside={!props.submitted}
      closeOnEsc={!props.submitted}
      onClose={props.onClose}
      showCloseIcon={!props.submitted}
      title={'Unarchive Category'}
      primaryButtonTitle={'Unarchive Category'}
      primaryButtonAction={props.onSubmit}
      primaryButtonColor={ButtonColorsEnum.secondary}
      primaryButtonDisabled={props.submitted}
      primaryButtonLoading={props.submitted}>
      <p>Unarchiving this Category will re-activate its Posts and Timeslots.</p>
    </Modal>
  );
};
